import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import "./MAgregarEditarEmpaquetadorEtapaPT.css";

function MAgregarEditarEmpaquetadorEtapaPT({
  origenComponente,
  registro = {},
  parametros,
  datosComplementarios,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
  modo, //solo disponible para agregar persona
}) {
  const { ecv_u, cv_u } = useContext(Contexto);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    form: null,
    datosForm: {},
    respuestaActualizacion: {},
    areaEtapa: {},
  });
  const [actualizaDatosTabla, setactualizaDatosTabla] = useState(null);

  useEffect(() => {
    console.log(origenComponente, registro, parametros, tipoEvento, datosComplementarios);
    const datosFormAPI = _api_.f_RelacionEmpaquetadoraEtapaPT({
      parametros: {
        modo: "DSF",
        codEmpaquetador: registro?.codigoEmpaquetador ?? "",
        codEtapa: datosComplementarios?.codigo ?? 0,
        datos: {},
      },
      origen: origenComponente,
      timeout: 5000,
    });

    datosFormAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          form: dPC.contenido.form,
          areaEtapa: dPC.contenido.areaEtapa,
        });
      }
    });
  }, []);

  const cambiarValor = (evento, valores, va, clave) => {
    // console.log(evento?.value)
    console.log(v_u.areaEtapa?.[evento?.value]);
    actualizaDatosTabla("codAreaTrabajo", v_u.areaEtapa?.[evento?.value] ?? "");
  };
  useEffect(() => {
    // console.log(v_u.datosForm);
  }, [v_u.datosForm]);

  return (
    <div className={"MAgregarEditarEmpaquetadorEtapaPTCSS-cuerpo"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
              errores_mostrar: false,
            });
          }}>
          {v_c.errores_mostrar && <_lul_.ListaUL texto={v_c.modal_mensaje} listaElementos={v_c.errores_lista} />}
          {!v_c.errores_mostrar && v_c.preConfirmar_mostrar && (
            <_preconf_.PreConfirmacion
              texto={`${
                (registro?.codEtapa?? 0) == 0 ? "¿Seguro que desea confirmar?" : "¿Seguro que desea confirmar los cambios?"
              }`}
              fBotonAceptar={() => {
                const actualizarDatosAPI = _api_.f_RelacionEmpaquetadoraEtapaPT({
                  parametros: {
                    modo: (registro?.codigoEmpaquetador ?? "") == 0 ? "INS" : "UPD",
                    codEmpaquetador: registro?.codigoEmpaquetador ?? "",
                    codEtapa: datosComplementarios?.codigo ?? 0,
                    datos: v_u.datosForm,
                  },
                  origen: origenComponente,
                  timeout: 20000,
                });
                actualizarDatosAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  console.log(dPC);
                  if (!dPC.error) {
                    _f_.asignar(ev_c, {
                      procesandoAccion_mostrar: false,
                      modal_titulo: "✅ Éxito",
                      postConfirmar_mostrar: true,
                    });
                    _f_.asignar(ev_u, {
                      respuestaActualizacion: dPC.contenido,
                    });
                  } else {
                    _f_.limpiarAsignacion(ev_c, Object.keys(v_c));
                  }
                });

                _f_.asignar(ev_c, {
                  preConfirmar_mostrar: false,
                  modal_titulo: "⏳ Procesando",
                  procesandoAccion_mostrar: true,
                });
              }}
              fBotonCancelar={() => {
                _f_.asignar(ev_c, { modal_mostrar: false });
              }}
            />
          )}
          {!v_c.errores_mostrar && v_c.procesandoAccion_mostrar && <_procAcc_.ProcesandoAccion />}
          {!v_c.errores_mostrar && v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              texto={
                (registro?.codigo ?? 0) == 0
                  ? `Se registro con éxito`
                  : `Se actualizó la información para el programa ${registro?.["Nombre del Programa"]}`
              }
              fBotonDeAcuerdo={() => {
                fCerrarComponente?.();
                fActualizarTablaTotal?.(true);
              }}></_posconf_.PostConfirmacion>
          )}
        </ModalInformacion>
      )}
      <_form_.Formulario
        form={v_u.form ?? []}
        dext={setactualizaDatosTabla}
        // onChangeCampos={{ codEtapa: cambiarValor }}
        fObtenerDatosFormulario={(datos) => {
          _f_.asignar(ev_u, { datosForm: datos });
        }}></_form_.Formulario>

      <div className={"MAgregarEditarEmpaquetadorEtapaPTCSS-opciones"}>
        <_btn_.Boton
          texto={`${registro?.codigo ? "Actualizar" : "Aceptar"}`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            console.log(v_u.datosForm);
            let error = false;
            let errores = [];
            if (v_u.datosForm?.codProducto == "") {
              error = true;
              errores.push("Es necesario seleccionar un producto.");
            }
            if (v_u.datosForm?.codEtapa == "") {
              error = true;
              errores.push("Es necesario seleccionar una etapa.");
            }

            if (error) {
              _f_.asignar(ev_c, {
                errores_lista: errores,
                modal_mostrar: true,
                errores_mostrar: true,
                modal_estilos: { anchoMI: "30rem" },
                modal_titulo: "❗Errores",
                // preConfirmar_mostrar: true,
              });
            } else {
              _f_.asignar(ev_c, {
                errores_mostrar: false,
                modal_mostrar: true,
                modal_estilos: { anchoMI: "30rem" },
                modal_titulo: "❗Confirmar Acción",
                preConfirmar_mostrar: true,
              });
            }
          }}
        />
        <_btn_.Boton
          texto={`Cancelar`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_rojo_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            fCerrarComponente?.();
          }}
        />
      </div>
    </div>
  );
}
export default MAgregarEditarEmpaquetadorEtapaPT;
